import React, { useContext, useRef } from 'react';
import { Editor } from '@tinymce/tinymce-react';

import { ConfigContext } from '../../Config/ConfigContext'
import useForm from '../../hooks/useForm'
import FormInput from '../../form/form-input'
import http from '../../utils/http'

import { useParams } from 'react-router-dom';
import {
    Box,
    Button,
    Chip,
    Container,
    Stack,
    Typography
} from '@mui/material';
import { camelCase } from 'lodash';

const onLoad = async ({
    values,
}) => {
    const emailTemplate = await http.get({}, `${values.config.uri.base}/email/template/${values.emailTemplateId}`);
    return {
        ...values,
        ...emailTemplate
    };
};

export default function EmailTemplateDetail() {
    const {
        emailTemplateId
    } = useParams();
    const { config } = useContext(ConfigContext);
    const {
        state,
        onChange
    } = useForm({
        initialState: {
            body: '',
            subject: '',
            from: '',
            emailTemplateId,
            name: '',
            config,
        },
        onLoad
    });

    // Group the regex matches into a new object 
    // so that you can iterate and show total counts of 
    // matches within the email template
    const replacementArray = [...state.values.body.matchAll(/{(.*?)}/g)]
        .reduce((previous, current) => {
            (previous[current[0]] = previous[current[0]] || []).push(current);

            return previous;
        }, {});

    const editorRef = useRef(null);
    return (
        <Container>
            <Stack direction={'row'}>
                <FormInput
                    path='name'
                    label='Template Name'
                    value={state.values.name}
                    error={state.errors.name}
                    onChange={(value, path) => {
                        value = camelCase(value)
                        onChange(value, path);
                    }}
                />

                <FormInput
                    path='subject'
                    label='Email Subject'
                    value={state.values.subject}
                    error={state.errors.subject}
                    onChange={onChange}
                />
                <FormInput
                    path='from'
                    label='From Address'
                    value={state.values.from}
                    error={state.errors.from}
                    onChange={onChange}
                />
            </Stack>
            <Box sx={{ marginTop: '10px', marginBottom: '10px' }}>
                <Typography>
                    Replacement Variables
                </Typography>
                {Object.keys(replacementArray).map((x, index) => {
                    const replacement = replacementArray[x];
                    return (
                        <Chip key={index} label={`${x} x${replacement.length}`} variant='outlined' />
                    )
                })}
            </Box>
            <Button
                sx={{ marginTop: '10px', marginBottom: '10px' }}
                variant='contained'
                onClick={async () => {
                    await http.put({
                        body: state.values.body,
                        subject: state.values.subject,
                        from: state.values.from,
                        name: state.values.name,
                    }, `${config.uri.base}/email/template/${emailTemplateId}`);
                }}
            >Save</Button>
            <Editor
                apiKey={config.emailEditor.apiKey}
                onInit={(evt, editor) => editorRef.current = editor}
                value={state.values.body}
                onEditorChange={(value) => {
                    onChange(value, 'body')
                }}
                init={{
                    height: 750,
                    menubar: false,
                    plugins: [
                        'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
                        'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
                        'insertdatetime', 'media', 'table', 'code', 'help', 'wordcount'
                    ],
                    toolbar: 'image | code | link | undo redo | blocks | ' +
                        'bold italic forecolor | alignleft aligncenter ' +
                        'alignright alignjustify | bullist numlist outdent indent | ' +
                        'removeformat | help',
                    content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
                    relative_urls: false,
                    remove_script_host: false,
                }}
            />

        </Container>
    );
}
